module.exports = __webpack_public_path__ + "static/media/hand-holding-box.4d395444.svg";